
      import CaretTop from './caret-top.vue'
      import type { App, Plugin } from 'vue'

      export const CaretTopPlugin: Plugin = {
        install(app: App) {
          app.component('CaretTop', CaretTop)
        },
      }
      export { CaretTop }
      